export default __webpack_public_path__ + "/assets/fonts/inter-cyrillic-ext-wght-normal.woff2";